import { render, staticRenderFns } from "./EditRemarkDialog.vue?vue&type=template&id=4dae5002&scoped=true"
import script from "./EditRemarkDialog.vue?vue&type=script&lang=ts"
export * from "./EditRemarkDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditRemarkDialog.vue?vue&type=style&index=0&id=4dae5002&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dae5002",
  null
  
)

export default component.exports